<h2 mat-dialog-title *ngIf="workRotationId">
    {{ 'EditWorkRotation' | translate: {Default: "Edit Work Rotation"} }}
</h2>
<h2 mat-dialog-title *ngIf="!workRotationId">
    {{ 'CreateNewWorkRotation' | translate: {Default: "Create New Work Rotation"} }}
</h2>

<mat-dialog-content >
    <div class="add-lookup-form" [formGroup]="form">
        <div class="form-container">
            <app-localization-text-form-field
                [formElement]="{ formControl: 'localizations', localizationValueParam: 'text', text: ('WorkRotationName' | translate: {Default: 'Work Rotation Name'}), disabled: 'false' }"
                [parentGroup]="form"
                [cultures]="cultures"
                [showTitle]="false"
                (emitAddtoFormArray)="addNewLocalization()"
                (emitDeleteFromFormArray)="deleteLocalization($event.index)"
            ></app-localization-text-form-field>
        </div>
    </div>

</mat-dialog-content>

<mat-dialog-actions *ngIf="form">
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">Close</button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="!form.valid">Save</button> 
</mat-dialog-actions>
